"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageStatus = void 0;

var _messagestatus = require("../actions/messagestatus");

var _generators = require("../../utils/generators");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ MESSAGE STATUS : REDUCER ~~~~~~~~~~ ========== */


var defaultState = {
  toaster: {
    top: [],
    bottom: []
  },
  notification: {
    top: [],
    bottom: []
  },
  incontent: {
    messages: []
  }
}; // REDUCER

var messageStatus = function messageStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var position;

  switch (action.type) {
    case _messagestatus.DISPLAY_MESSAGE:
      var message = _objectSpread({}, action.message, {
        id: (0, _generators.generateId)()
      });

      position = action.message.type === 'incontent' ? 'messages' : action.message.align.includes('top') ? 'top' : 'bottom';
      return _objectSpread({}, state, _defineProperty({}, "".concat(action.message.type), _objectSpread({}, state["".concat(action.message.type)], _defineProperty({}, position, state["".concat(action.message.type)][position].concat(message)))));

    case _messagestatus.REMOVE_MESSAGE:
      // position = action.alignment.includes('top') ? 'top' : 'bottom';
      position = action.alignment === 'messages' ? 'messages' : action.alignment.includes('top') ? 'top' : 'bottom';
      return _objectSpread({}, state, _defineProperty({}, "".concat(action.messageType), _objectSpread({}, state["".concat(action.messageType)], _defineProperty({}, position, state["".concat(action.messageType)][position].filter(function (message) {
        return message[action.filterProp] !== action.filterVal;
      })))));

    case _messagestatus.CLEAR_ALL_STATES:
      return defaultState;

    default:
      return state;
  }
};

exports.messageStatus = messageStatus;